import { render, staticRenderFns } from "./Sitesweb.vue?vue&type=template&id=2be869fd&"
import script from "./Sitesweb.vue?vue&type=script&lang=js&"
export * from "./Sitesweb.vue?vue&type=script&lang=js&"
import style0 from "./Sitesweb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports